import { createApp } from 'vue';
import RawToJpgConverter from '../Components/RawToJpgConverter.vue';

const root = document.getElementById('raw-to-jpg-converter');
if (root) {
  createApp(RawToJpgConverter).mount('#raw-to-jpg-converter');
}
